"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IActiveTag.js.map